import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import BalanceDanamon from "../../models/BalanceDanamon";
import {
  saveState,
  loadState,
  removeState,
} from "../browser-storage/browser-storage";

type InitialState = {
  balanceDanamon: BalanceDanamon;
};
const type = "balanceDanamon";

const initialState: InitialState = {
  balanceDanamon: loadState(type),
};

export const balanceDanamonSlice = createSlice({
  name: type,
  initialState: initialState,
  reducers: {
    setBalanceDanamon: (state, action: PayloadAction<BalanceDanamon>) => {
      state.balanceDanamon = action.payload;
      saveState(type, action.payload);
    },
    removeBalanceDanamon: (state) => {
      state.balanceDanamon = {};
      removeState(type);
    },
  },
});

// Action creators are generated for each case reducer function
export const { setBalanceDanamon, removeBalanceDanamon } =
  balanceDanamonSlice.actions;

export default balanceDanamonSlice.reducer;
